import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, Youtube, ArrowUpRight } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Enter a valid email");
      return;
    }
    toast.success("Thank you for subscribing. Updates from the front lines coming your way.");
    setEmail("");
  };

  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0C] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.3em] uppercase text-[#E85D04] mb-6">
              Join The Mission
            </div>
            <h2 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.95] tracking-tight">
              A voice for the voiceless. <br />
              <span className="text-stroke">A hand for the forgotten.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="text-white/60 mb-6 leading-relaxed">
              Get monthly dispatches from rescue operations, grant recipients, and the
              communities we serve.
            </p>
            <form onSubmit={handleSubscribe} className="flex border-b border-white/30 focus-within:border-[#E85D04] transition-colors">
              <input
                data-testid="newsletter-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                className="flex-1 bg-transparent text-white py-4 outline-none placeholder:text-white/30"
              />
              <button
                data-testid="newsletter-submit"
                type="submit"
                className="text-white/80 hover:text-[#E85D04] transition-colors p-2"
                aria-label="Subscribe"
              >
                <ArrowUpRight size={22} />
              </button>
            </form>
          </div>
        </div>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-10 text-sm text-white/60">
          <div>
            <div className="text-white font-serif-display text-lg mb-4">John Depp Foundation</div>
            <p className="leading-relaxed">Global Animal Rights Foundation. Est. 2018.</p>
            <p className="mt-2 text-white/40">jreardonfoundation.com</p>
          </div>
          <div>
            <div className="text-white/40 uppercase text-xs tracking-[0.25em] mb-4">Foundation</div>
            <ul className="space-y-2">
              <li><Link to="/causes" className="hover:text-white">Causes</Link></li>
              <li><Link to="/grants" className="hover:text-white">Grant Program</Link></li>
              <li><Link to="/blog" className="hover:text-white">Field Stories</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-white/40 uppercase text-xs tracking-[0.25em] mb-4">Get Involved</div>
            <ul className="space-y-2">
              <li><Link to="/donate" className="hover:text-white">Donate</Link></li>
              <li><Link to="/volunteer" className="hover:text-white">Volunteer</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-white/40 uppercase text-xs tracking-[0.25em] mb-4">Follow</div>
            <div className="flex gap-4">
              <a href="#" aria-label="Instagram" className="hover:text-[#E85D04]"><Instagram size={18} /></a>
              <a href="#" aria-label="Twitter" className="hover:text-[#E85D04]"><Twitter size={18} /></a>
              <a href="#" aria-label="Facebook" className="hover:text-[#E85D04]"><Facebook size={18} /></a>
              <a href="#" aria-label="Youtube" className="hover:text-[#E85D04]"><Youtube size={18} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40 tracking-wider">
          <div>© {new Date().getFullYear()} John Depp Foundation. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
